import { Search } from 'lucide-react'
import { useMemo, useState } from 'react'
import { ExerciseMedia } from '../../components/ExerciseMedia'
import { Modal } from '../../components/Modal'
import { useStrata } from '../../data/StrataProvider'
import type { Exercise, ExerciseCategory } from '../../domain/types'
import { ExerciseDetail } from './ExerciseDetail'

const categories: ('Todos' | ExerciseCategory)[] = ['Todos', 'Pecho', 'Espalda', 'Hombro', 'Bíceps', 'Tríceps', 'Piernas', 'Abs', 'Anillas', 'HYROX']

export function ExerciseLibrary({ onClose }: { onClose: () => void }) {
  const { state } = useStrata()
  const [search, setSearch] = useState('')
  const [category, setCategory] = useState<(typeof categories)[number]>('Todos')
  const [selected, setSelected] = useState<Exercise>()
  const filtered = useMemo(() => {
    const query = search.trim().toLocaleLowerCase('es-MX')
    return state.exercises.filter((exercise) => {
      const haystack = [exercise.name, ...exercise.aliases ?? [], exercise.equipment, exercise.category].join(' ').toLocaleLowerCase('es-MX')
      return (category === 'Todos' || exercise.category === category) && haystack.includes(query)
    })
  }, [state.exercises, category, search])

  return (
    <Modal title="Ejercicios" onClose={onClose} large>
      <div className="search-box"><Search size={18} /><input autoFocus placeholder="Buscar ejercicio" value={search} onChange={(event) => setSearch(event.target.value)} /></div>
      <div className="category-strip">{categories.map((item) => <button key={item} className={category === item ? 'selected' : ''} onClick={() => setCategory(item)}>{item}</button>)}</div>
      <p className="library-count">{filtered.length} {filtered.length === 1 ? 'ejercicio' : 'ejercicios'}</p>
      <div className="library-list">
        {filtered.map((exercise) => (
          <button key={exercise.id} onClick={() => setSelected(exercise)}>
            <ExerciseMedia exercise={exercise} size={58} />
            <span><strong>{exercise.name}</strong><small>{exercise.category} · {exercise.equipment}</small></span>
            <i>›</i>
          </button>
        ))}
        {!filtered.length && <p className="library-empty">No encontré ejercicios con esa búsqueda.</p>}
      </div>
      {selected && <Modal title={selected.name} onClose={() => setSelected(undefined)}><ExerciseDetail exercise={selected} /></Modal>}
    </Modal>
  )
}
